/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */






export const LIST_ASSET_FORM_DATA = [
      {
        label: "Select Storefront",
        name: "selectStorefront",
        type: "async-select",
        fieldProps: {
            isMulti: false,
            initialOptions: [
                {
                    value: "vlinderMarketPlace",
                    label: "Vlinder Market Place"
                },
         
            ]
        }
    },
    {
        label: "Select Category",
        name: "selectCategory",
        type: "select-picker",
        fieldProps: {
            isMulti: false,
            initialOptions: []
        }
    },
 
    {
        label: "Enter Price in USD",
        name: "fiat",
        type: "currency-input",
        fieldProps: {
            intlconfig: {
                locale: "en-US",
                currency: "USD"
            },
            allowNegativeValue: false,
            decimalLimit: 20,
            prefix: "$"
        }
    },
    {
        label: "Enter Price in Ether",
        name: "crypto",
        type: "currency-input",
        fieldProps: {
            intlconfig: {
                locale: "en-US",
                currency: "ETH"
            },
            allowNegativeValue: false,
            decimalLimit: 10,
            prefix: "Ξ"
        }
    },

    // {
    //     label: "Enter Price in USD ($)",
    //     name: "fiat",
    //     type: "number-input",
    //     fieldProps: {}
    // },
    // {
    //     label: "Enter Price in Crypto (Ξ)",
    //     name: "crypto",
    //     type: "number-input",
    //     fieldProps: {}
    // },



 
    ]

    export const LIST_ASSET_FIELDS: any ={

        selectCategory: {
            validators: {
                notEmpty: {
                    message: "Please select the category!"
                },
    
            }
        },
        fiat: {
            validators: {
                notEmpty: {
                    message: "Please enter the asset price"
                },
    
            }
        }, 
        crypto: {
            validators: {
                notEmpty: {
                    message: "Please enter the asset price"
                },
    
            }
        }, 
        selectStorefront: {
            validators: {
                notEmpty: {
                    message: "Please select the storefront to list"
                },
    
            }
        }
    }